// import React from 'react';
// import { motion } from 'framer-motion';
// import { Calendar, Building2, DollarSign, FileText, Download, ExternalLink } from 'lucide-react';
// import { formatCurrency } from '../utils/excelExport';
// import { downloadFromIPFS } from '../utils/api';

// const RecordCard = ({ record, index }) => {
//   const handleDownloadDocument = () => {
//     if (record.documentHash && record.documentHash !== 'N/A') {
//       const downloadUrl = downloadFromIPFS(record.documentHash);
//       window.open(downloadUrl, '_blank');
//     }
//   };

//   const hasDocument = record.documentHash && record.documentHash !== '' && record.documentHash !== 'N/A';

//   return (
//     <motion.div
//       className="record-card"
//       initial={{ opacity: 0, y: 20 }}
//       animate={{ opacity: 1, y: 0 }}
//       transition={{ delay: index * 0.1 }}
//       whileHover={{ y: -4 }}
//     >
//       <div className="record-header">
//         <div className="record-invoice">
//           <FileText size={20} />
//           <span>{record.invoiceNumber}</span>
//         </div>
//         <div className={`record-status status-${record.paymentStatus?.toLowerCase() || 'pending'}`}>
//           {record.paymentStatus || 'N/A'}
//         </div>
//       </div>

//       <div className="record-body">
//         <div className="record-field">
//           <Building2 size={16} className="field-icon" />
//           <div>
//             <div className="field-label">Company</div>
//             <div className="field-value">{record.companyName}</div>
//           </div>
//         </div>

//         <div className="record-field">
//           <DollarSign size={16} className="field-icon" />
//           <div>
//             <div className="field-label">Amount</div>
//             <div className="field-value amount">{formatCurrency(record.amount)}</div>
//           </div>
//         </div>

//         <div className="record-field">
//           <Calendar size={16} className="field-icon" />
//           <div>
//             <div className="field-label">Date</div>
//             <div className="field-value">{record.date}</div>
//           </div>
//         </div>

//         <div className="record-details">
//           <div className="detail-row">
//             <span className="detail-label">Type:</span>
//             <span className="detail-value">{record.transactionType}</span>
//           </div>
//           <div className="detail-row">
//             <span className="detail-label">Category:</span>
//             <span className="detail-value">{record.category}</span>
//           </div>
//           <div className="detail-row">
//             <span className="detail-label">FY:</span>
//             <span className="detail-value">{record.financialYear}</span>
//           </div>
//           {record.taxNumber !== 'N/A' && (
//             <div className="detail-row">
//               <span className="detail-label">Tax Number:</span>
//               <span className="detail-value">{record.taxNumber}</span>
//             </div>
//           )}
//           {record.notes !== 'N/A' && (
//             <div className="detail-row full-width">
//               <span className="detail-label">Notes:</span>
//               <span className="detail-value">{record.notes}</span>
//             </div>
//           )}
//         </div>
//       </div>

//       {hasDocument && (
//         <div className="record-footer">
//           <button className="download-button" onClick={handleDownloadDocument}>
//             <Download size={16} />
//             <span>Download Document</span>
//             <ExternalLink size={14} />
//           </button>
//         </div>
//       )}

//       <style jsx="true">{`
//         .record-card {
//           background: white;
//           border-radius: 16px;
//           padding: 24px;
//           box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
//           transition: all 0.3s ease;
//           border: 2px solid transparent;
//         }

//         .record-card:hover {
//           box-shadow: 0 12px 24px rgba(0, 0, 0, 0.12);
//           border-color: #667eea;
//         }

//         .record-header {
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           margin-bottom: 20px;
//           padding-bottom: 16px;
//           border-bottom: 2px solid #f1f5f9;
//         }

//         .record-invoice {
//           display: flex;
//           align-items: center;
//           gap: 8px;
//           font-weight: 700;
//           font-size: 18px;
//           color: #1e293b;
//         }

//         .record-status {
//           padding: 6px 16px;
//           border-radius: 20px;
//           font-size: 13px;
//           font-weight: 600;
//           text-transform: capitalize;
//         }

//         .status-paid {
//           background: #d1fae5;
//           color: #065f46;
//         }

//         .status-pending {
//           background: #fef3c7;
//           color: #92400e;
//         }

//         .status-partial {
//           background: #dbeafe;
//           color: #1e40af;
//         }

//         .status-n\\/a {
//           background: #f1f5f9;
//           color: #64748b;
//         }

//         .record-body {
//           display: flex;
//           flex-direction: column;
//           gap: 16px;
//         }

//         .record-field {
//           display: flex;
//           gap: 12px;
//           align-items: flex-start;
//         }

//         .field-icon {
//           color: #667eea;
//           margin-top: 2px;
//         }

//         .field-label {
//           font-size: 12px;
//           color: #94a3b8;
//           font-weight: 500;
//           text-transform: uppercase;
//           letter-spacing: 0.5px;
//           margin-bottom: 4px;
//         }

//         .field-value {
//           font-size: 15px;
//           color: #1e293b;
//           font-weight: 500;
//         }

//         .field-value.amount {
//           font-size: 20px;
//           font-weight: 700;
//           color: #667eea;
//         }

//         .record-details {
//           margin-top: 8px;
//           padding-top: 16px;
//           border-top: 1px solid #f1f5f9;
//           display: grid;
//           grid-template-columns: repeat(2, 1fr);
//           gap: 12px;
//         }

//         .detail-row {
//           display: flex;
//           flex-direction: column;
//           gap: 4px;
//         }

//         .detail-row.full-width {
//           grid-column: 1 / -1;
//         }

//         .detail-label {
//           font-size: 11px;
//           color: #94a3b8;
//           font-weight: 600;
//           text-transform: uppercase;
//           letter-spacing: 0.5px;
//         }

//         .detail-value {
//           font-size: 13px;
//           color: #475569;
//           font-weight: 500;
//         }

//         .record-footer {
//           margin-top: 20px;
//           padding-top: 16px;
//           border-top: 2px solid #f1f5f9;
//         }

//         .download-button {
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           gap: 8px;
//           width: 100%;
//           padding: 12px;
//           background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
//           color: white;
//           border: none;
//           border-radius: 8px;
//           font-weight: 600;
//           font-size: 14px;
//           cursor: pointer;
//           transition: all 0.3s ease;
//         }

//         .download-button:hover {
//           transform: translateY(-2px);
//           box-shadow: 0 8px 16px rgba(102, 126, 234, 0.3);
//         }

//         @media (max-width: 768px) {
//           .record-details {
//             grid-template-columns: 1fr;
//           }

//           .record-header {
//             flex-direction: column;
//             align-items: flex-start;
//             gap: 12px;
//           }
//         }
//       `}</style>
//     </motion.div>
//   );
// };

// export default RecordCard;
import React from "react";
import { motion } from "framer-motion";
import {
  Calendar,
  Building2,
  DollarSign,
  FileText,
  Download,
  ExternalLink,
  Clock,
  Link2,
} from "lucide-react";
import { formatCurrency } from "../utils/excelExport";
import { downloadFromIPFS } from "../utils/api";

const RecordCard = ({ record, index }) => {
  const handleDownloadDocument = () => {
    if (record.documentHash && record.documentHash !== "N/A") {
      const downloadUrl = downloadFromIPFS(record.documentHash);
      window.open(downloadUrl, "_blank");
    }
  };

  const hasDocument =
    record.documentHash &&
    record.documentHash !== "" &&
    record.documentHash !== "N/A";
  const hasTxHash =
    record.transactionHash &&
    record.transactionHash !== "N/A" &&
    record.transactionHash !== "";

  // Format timestamp to time (HH:MM:SS)
  const formatTime = (timestamp) => {
    if (!timestamp) return "N/A";
    const date = new Date(timestamp * 1000);
    return date.toLocaleTimeString("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });
  };

  // Truncate transaction hash for display
  const truncateTxHash = (hash) => {
    if (!hash || hash.length < 20) return hash;
    return `${hash.slice(0, 8)}...${hash.slice(-6)}`;
  };

  return (
    <motion.div
      className="record-card"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.1 }}
      whileHover={{ y: -4 }}
    >
      <div className="record-header">
        <div className="record-invoice">
          <FileText size={20} />
          <span>{record.invoiceNumber}</span>
        </div>
        <div
          className={`record-status status-${
            record.paymentStatus?.toLowerCase() || "pending"
          }`}
        >
          {record.paymentStatus || "N/A"}
        </div>
      </div>

      <div className="record-body">
        <div className="record-field">
          <Building2 size={16} className="field-icon" />
          <div>
            <div className="field-label">Company</div>
            <div className="field-value">{record.companyName}</div>
          </div>
        </div>

        <div className="record-field">
          <DollarSign size={16} className="field-icon" />
          <div>
            <div className="field-label">Amount</div>
            <div className="field-value amount">
              {formatCurrency(record.amount)}
            </div>
          </div>
        </div>

        <div className="record-field">
          <Calendar size={16} className="field-icon" />
          <div>
            <div className="field-label">Date</div>
            <div className="field-value">{record.date}</div>
          </div>
        </div>

        {/* ✅ NEW: Time Field */}
        <div className="record-field">
          <Clock size={16} className="field-icon" />
          <div>
            <div className="field-label">Time</div>
            <div className="field-value">{formatTime(record.timestamp)}</div>
          </div>
        </div>

        <div className="record-details">
          <div className="detail-row">
            <span className="detail-label">Type:</span>
            <span className="detail-value">{record.transactionType}</span>
          </div>
          <div className="detail-row">
            <span className="detail-label">Category:</span>
            <span className="detail-value">{record.category}</span>
          </div>
          <div className="detail-row">
            <span className="detail-label">FY:</span>
            <span className="detail-value">{record.financialYear}</span>
          </div>
          {record.taxNumber !== "N/A" && (
            <div className="detail-row">
              <span className="detail-label">Tax Number:</span>
              <span className="detail-value">{record.taxNumber}</span>
            </div>
          )}
          {record.notes !== "N/A" && (
            <div className="detail-row full-width">
              <span className="detail-label">Notes:</span>
              <span className="detail-value">{record.notes}</span>
            </div>
          )}

          {/* ✅ NEW: Transaction Hash */}
          {hasTxHash && (
            <div className="detail-row full-width transaction-hash-row">
              <span className="detail-label">Transaction Hash:</span>
              <a
                href={`https://polygonscan.com/tx/${record.transactionHash}`}
                target="_blank"
                rel="noopener noreferrer"
                className="tx-hash-link"
              >
                <code className="tx-hash-value">
                  {truncateTxHash(record.transactionHash)}
                </code>
                <Link2 size={14} className="external-link-icon" />
              </a>
            </div>
          )}
        </div>
      </div>

      {hasDocument && (
        <div className="record-footer">
          <button className="download-button" onClick={handleDownloadDocument}>
            <Download size={16} />
            <span>Download Document</span>
            <ExternalLink size={14} />
          </button>
        </div>
      )}

      <style jsx="true">{`
        .record-card {
          background: white;
          border-radius: 16px;
          padding: 24px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
          transition: all 0.3s ease;
          border: 2px solid transparent;
        }

        .record-card:hover {
          box-shadow: 0 12px 24px rgba(0, 0, 0, 0.12);
          border-color: #667eea;
        }

        .record-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 20px;
          padding-bottom: 16px;
          border-bottom: 2px solid #f1f5f9;
        }

        .record-invoice {
          display: flex;
          align-items: center;
          gap: 8px;
          font-weight: 700;
          font-size: 18px;
          color: #1e293b;
        }

        .record-status {
          padding: 6px 16px;
          border-radius: 20px;
          font-size: 13px;
          font-weight: 600;
          text-transform: capitalize;
        }

        .status-paid {
          background: #d1fae5;
          color: #065f46;
        }

        .status-pending {
          background: #fef3c7;
          color: #92400e;
        }

        .status-partial {
          background: #dbeafe;
          color: #1e40af;
        }

        .status-n\\/a {
          background: #f1f5f9;
          color: #64748b;
        }

        .record-body {
          display: flex;
          flex-direction: column;
          gap: 16px;
        }

        .record-field {
          display: flex;
          gap: 12px;
          align-items: flex-start;
        }

        .field-icon {
          color: #667eea;
          margin-top: 2px;
        }

        .field-label {
          font-size: 12px;
          color: #94a3b8;
          font-weight: 500;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          margin-bottom: 4px;
        }

        .field-value {
          font-size: 15px;
          color: #1e293b;
          font-weight: 500;
        }

        .field-value.amount {
          font-size: 20px;
          font-weight: 700;
          color: #667eea;
        }

        .record-details {
          margin-top: 8px;
          padding-top: 16px;
          border-top: 1px solid #f1f5f9;
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 12px;
        }

        .detail-row {
          display: flex;
          flex-direction: column;
          gap: 4px;
        }

        .detail-row.full-width {
          grid-column: 1 / -1;
        }

        .detail-label {
          font-size: 11px;
          color: #94a3b8;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .detail-value {
          font-size: 13px;
          color: #475569;
          font-weight: 500;
        }

        /* ✅ NEW: Transaction Hash Styles */
        .transaction-hash-row {
          margin-top: 8px;
          padding-top: 12px;
          border-top: 1px solid #f1f5f9;
        }

        .tx-hash-link {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          padding: 8px 12px;
          background: linear-gradient(135deg, #667eea15 0%, #764ba215 100%);
          border: 1px solid #667eea40;
          border-radius: 8px;
          text-decoration: none;
          transition: all 0.3s ease;
          margin-top: 4px;
        }

        .tx-hash-link:hover {
          background: linear-gradient(135deg, #667eea25 0%, #764ba225 100%);
          border-color: #667eea;
          transform: translateX(4px);
        }

        .tx-hash-value {
          font-family: "SF Mono", "Monaco", "Inconsolata", "Fira Code",
            monospace;
          font-size: 13px;
          color: #667eea;
          font-weight: 600;
          letter-spacing: -0.5px;
        }

        .external-link-icon {
          color: #667eea;
          opacity: 0.7;
          transition: all 0.3s ease;
        }

        .tx-hash-link:hover .external-link-icon {
          opacity: 1;
          transform: translateX(2px) translateY(-2px);
        }

        .record-footer {
          margin-top: 20px;
          padding-top: 16px;
          border-top: 2px solid #f1f5f9;
        }

        .download-button {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          width: 100%;
          padding: 12px;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: white;
          border: none;
          border-radius: 8px;
          font-weight: 600;
          font-size: 14px;
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .download-button:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 16px rgba(102, 126, 234, 0.3);
        }

        @media (max-width: 768px) {
          .record-details {
            grid-template-columns: 1fr;
          }

          .record-header {
            flex-direction: column;
            align-items: flex-start;
            gap: 12px;
          }
        }
      `}</style>
    </motion.div>
  );
};

export default RecordCard;
